// extracted by mini-css-extract-plugin
export default {"container":"style_container__Tp9Wk","header":"style_header__qLBTh","main":"style_main__k7-Vn"};